/**
 * Số phút → chữ đời thường, dùng chung máy chủ / quầy / Mini App (K5, ADR-099).
 *
 * `30` → "30 phút" · `60` → "1 tiếng" · `90` → "90 phút" · `120` → "2 tiếng" · `1440` → "1 ngày" · `1500` → "25 tiếng".
 * Dùng "tiếng" (đời thường: "trước 2 tiếng"), KHÔNG dùng "giờ" — dễ đọc nhầm thành mốc giờ "2 giờ".
 *
 * `0` → "0 phút": người gọi tự nói câu riêng cho "sát giờ". Số âm / lẻ / không hữu hạn là lỗi lập trình → ném
 * (không lặng lẽ in "NaN phút" lên màn khách).
 */
export function chuKhoangPhut(phut: number): string {
  if (!Number.isInteger(phut) || phut < 0) {
    throw new RangeError(`chuKhoangPhut: cần số nguyên phút không âm, nhận ${String(phut)}`)
  }
  // U+00A0 giữa số và đơn vị: dòng hẹp trên điện thoại không được tách "2" khỏi "tiếng".
  if (phut > 0 && phut % 1440 === 0) return `${phut / 1440}\u00a0ngày`
  if (phut > 0 && phut % 60 === 0) return `${phut / 60}\u00a0tiếng`
  return `${phut}\u00a0phút`
}

/** Số phút hợp lệ để in (nguyên, ≥ 0)? Dùng ở client trước khi tin một số do máy chủ cũ / lạ gửi. */
export function laSoPhutHopLe(x: unknown): x is number {
  return typeof x === 'number' && Number.isInteger(x) && x >= 0
}
